export default "__VITE_ASSET__3022ecf3__"